import { render } from "./ModalAdicionarAtivoItem.vue?vue&type=template&id=4b292709&scoped=true"
import script from "./ModalAdicionarAtivoItem.vue?vue&type=script&lang=js"
export * from "./ModalAdicionarAtivoItem.vue?vue&type=script&lang=js"

import "./ModalAdicionarAtivoItem.vue?vue&type=style&index=0&id=4b292709&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b292709"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QIcon,QTabs,QTab,QScrollArea,QBtn,QInput,QSelect});
